import { createSelector } from 'reselect';
import basketSelector from 'selectors/basket/basketSelector';
import { hasPickupBasketSelector } from 'selectors/basket/hasPickupBasketSelector';
import { showGuestCheckoutForBopisAndSddAbTestSelector } from 'viewModel/selectors/testTarget/showGuestCheckoutForBopisAndSddAbTestSelector';

const isGuestCheckoutEnabledForBopisSelector = createSelector(
    basketSelector,
    hasPickupBasketSelector,
    showGuestCheckoutForBopisAndSddAbTestSelector,
    (basket, hasPickupBasket, showGuestCheckoutForBopisAndSddAbTest) => {
        const isEnabledInBasket = basket?.pickupBasket?.isGuestCheckoutEnabled || false;

        // When the A/B test is off, don't let BOPIS baskets fall through the BOPIS guest-checkout killswitch —
        // the BOPIS experience is what the A/B test is meant to gate, so opt those users out even if the backend flag is on.
        if (isEnabledInBasket && !showGuestCheckoutForBopisAndSddAbTest && hasPickupBasket) {
            return false;
        }

        return isEnabledInBasket;
    }
);

export { isGuestCheckoutEnabledForBopisSelector };
